import type {
  AddBookmarkMutation,
  AddBookmarkMutationVariables,
  DeleteBookmarkMutation,
  DeleteBookmarkMutationVariables,
  Enum_Bookmark_Category,
  ExistByRelationIdQuery,
  ExistByRelationIdQueryVariables,
  BookmarkInput,
  BookmarkPageQuery,
  BookmarkPageQueryVariables,
  FetchResourcesByIdsQuery,
  FetchResourcesByIdsQueryVariables,
  FindByRelationIdQuery,
  FindByRelationIdQueryVariables,
  BookmarksPageableByUserIdQueryVariables,
  BookmarksPageableByUserIdQuery,
} from '@edwin-group/cj-graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { getAuthentication } from '@/hooks/useAuthentication';

import {
  QUERY_EXIST_BOOKMARK,
  QUERY_BOOKMARK_PAGE,
  QUERY_FIND_BOOKMARK,
  QUERY_FETCH_RESOURCES_BY_IDS,
  MUTATION_ADD_BOOKMARK,
  MUTATION_DELETE_BOOKMARK,
  QUERY_BOOKMARKS,
} from '@edwin-group/cj-graphql';

export const fetchUserBookmarks = async (_type: Enum_Bookmark_Category, size: number) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<BookmarksPageableByUserIdQuery, BookmarksPageableByUserIdQueryVariables>({
      query: QUERY_BOOKMARKS,
      variables: {
        size,
        staffId: getAuthentication()?.user?.documentId || '',
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const fetchResourcesByIds = async (ids: string[]) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchResourcesByIdsQuery, FetchResourcesByIdsQueryVariables>({
      query: QUERY_FETCH_RESOURCES_BY_IDS,
      variables: {
        ids,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const addBookmark = async (input: BookmarkInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<AddBookmarkMutation, AddBookmarkMutationVariables>({
      mutation: MUTATION_ADD_BOOKMARK,
      variables: {
        data: input,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const removeBookmark = async (id: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>({
      mutation: MUTATION_DELETE_BOOKMARK,
      variables: {
        id,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const existBookmark = async (relationId: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ExistByRelationIdQuery, ExistByRelationIdQueryVariables>({
      query: QUERY_EXIST_BOOKMARK,
      variables: {
        relationId: relationId,
        staffId: getAuthentication()?.user?.documentId || '',
      },
      fetchPolicy: 'no-cache',
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const findBookmark = async (relationId: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FindByRelationIdQuery, FindByRelationIdQueryVariables>({
      query: QUERY_FIND_BOOKMARK,
      variables: {
        relationId: relationId,
        staffId: getAuthentication()?.user?.documentId || '',
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const fetchBookmarkPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<BookmarkPageQuery, BookmarkPageQueryVariables>({
      query: QUERY_BOOKMARK_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};
